var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.522 13.627c0 1.748-1.461 3.155-3.277 3.155-1.8 0-3.26-1.407-3.245-3.155C4 9.716 6.97 7.849 8.737 7.079c.616-.267 1.293.178 1.293.815a.899.899 0 0 1-.477.77c-1.046.607-1.662 1.244-2 1.837 1.661.148 2.969 1.482 2.969 3.126Zm8.478 0c0 1.748-1.458 3.156-3.253 3.156-1.811 0-3.269-1.408-3.269-3.156 0-3.896 2.962-5.778 4.742-6.548.614-.267 1.289.178 1.289.815a.899.899 0 0 1-.476.77c-1.043.608-1.657 1.245-1.995 1.837C17.696 10.65 19 11.983 19 13.627Z"
  })));
};

export default SvgQuote;